/**
 * Slick Carousel
 */

// Dependencies
require('slick');

// Cached elements
const $el = {
	slider: $('.js-slick'),
	slider_alt: $('.js-slick-alt'),
};

export default function init() {
	// Initialise Slick
	$el.slider.each(function(){
		$(this).slick({
			// global 
			speed: 300,
		  	infinite: true,
		  	adaptiveHeight: false,
		  	slide: '.js-slide',

		  	//move slides when swiping up...
		  	// verticalSwiping: true,

		  	// local
		  	centerMode: $(this).data('center'),
		  	autoplay: $(this).data('autoplay'),
		  	autoplaySpeed: $(this).data('autoplayspeed'),
			arrows: $(this).data('arrows'),
			dots: $(this).data('dots'),
		  	slidesToShow: $(this).data('slidestoshow'),
		  	slidesToScroll: $(this).data('slidestoscroll'),
		  	nextArrow: '<button class="slick-next"><svg><use xlink:href="#chevron"></use></svg></button>',
		  	prevArrow: '<button class="slick-prev"><svg><use xlink:href="#chevron"></use></svg></button>',
		  	responsive: [
			    {
			      breakpoint: 990,
			      settings: {
			        slidesToShow: $(this).data('slidestoshow@medium'),
			        slidesToScroll: $(this).data('slidestoscroll@medium')
			      }
			    },
			    {
			      breakpoint: 768,
			      settings: {
			        slidesToShow: $(this).data('slidestoshow@small'),
			        slidesToScroll: $(this).data('slidestoscroll@small')
			      }
			    },
			    {
			      breakpoint: 767,
			      settings: {
			        slidesToShow: $(this).data('slidestoshow@xsmall'),
			        slidesToScroll: $(this).data('slidestoscroll@xsmall')
			      }
			    }
			]
		})
		}).on('afterChange', function(currentSlide){
			$(this).find('.slick-slide').removeClass('is-active');
			$(this).find('.slick-active').addClass('is-active');
		});

	$el.slider_alt.each(function(){
		$(this).slick({
			// global 
			speed: 300,
		  	infinite: true,
		  	adaptiveHeight: false,
		  	slide: '.js-slide',

		  	//move slides when swiping up...
		  	// verticalSwiping: true,

		  	// local
		  	centerMode: $(this).data('center'),
		  	autoplay: $(this).data('autoplay'),
		  	autoplaySpeed: $(this).data('autoplayspeed'),
			arrows: $(this).data('arrows'),
			dots: $(this).data('dots'),
			
		  	slidesToShow: $(this).data('slidestoshow'),
		  	slidesToScroll: $(this).data('slidestoscroll'),
		  	prevArrow: '<button class="slick-prev"><svg><use xlink:href="#arrow-bold"></use></svg></button>',
		  	nextArrow: '<button class="slick-next"><svg><use xlink:href="#arrow-bold"></use></svg></button>',
		  	appendArrows: $(this).parent().find('.slick-custom-nav__arrows'),
		  	appendDots: $(this).parent().find('.slick-custom-nav__dots'),
		  	responsive: [
			    {
			      breakpoint: 990,
			      settings: {
			        slidesToShow: $(this).data('slidestoshow@medium'),
			        slidesToScroll: $(this).data('slidestoscroll@medium')
			      }
			    },
			    {
			      breakpoint: 768,
			      settings: {
			        slidesToShow: $(this).data('slidestoshow@small'),
			        slidesToScroll: $(this).data('slidestoscroll@small')
			      }
			    },
			    {
			      breakpoint: 767,
			      settings: {
			        slidesToShow: $(this).data('slidestoshow@xsmall'),
			        slidesToScroll: $(this).data('slidestoscroll@xsmall')
			      }
			    }
			]
		})
		}).on('afterChange', function(currentSlide){
			$(this).find('.slick-slide').removeClass('is-active');
			$(this).find('.slick-active').addClass('is-active');
		});
};